<template>
  <div :class="$style.columns_settings_wrapper">
    <div :class="$style.wrapper_label">
      {{ locales('export_row_settings') }}
    </div>
    <div :class="$style.stickyTabs">
      <vgp-tabs
        v-if="tabs.length && customColumns.length"
        :tabs="tabs"
        active-by="type"
        :active="activeTab"
        :small="true"
        :styles="{ paddingLeft: '12px'}"
        @onToggle="onChangeTab"
      />
    </div>

    <div
      v-if="activeTab.type === 'standartColumns'"
    >
      <div :class="[$style.standart_columns_list]">
        <div
          v-for="(cols, groupName) in standartColumns"
          :key="groupName"
          :class="$style.standart_columns_list__group"
        >
          <div :class="$style.title">
            <div>
              {{ locales(`standart_columns_group_${groupName}`) }}
            </div>
            <span :class="$style.line" />
          </div>
          <div
            v-for="(item, index) in cols"
            :key="index"
            :class="$style.item"
          >
            <div :class="$style.item__row">
              <svg-sprite
                :name="item.icon"
              />
              <div :class="$style.name">
                {{ item.label }}
              </div>
              <div :class="$style.right_side">
                <div :class="$style.checkbox">
                  <vgp-checkbox
                    :size="16"
                    :checked="item.isChecked"
                    @update:checked="handleCheckboxChange(item, false)"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="item.option"
              :class="[$style.item__row, $style.option, advancedOptions[item.id].disabled ? $style.option_disable : '']"
            >
              <svg-sprite
                :name="item.optionIcon"
              />
              <div :class="$style.name">
                {{ item.optionValue }}
              </div>
              <div :class="$style.checkbox">
                <vgp-checkbox
                  :size="16"
                  :checked="advancedOptions[item.id].isChecked"
                  :is-disable="advancedOptions[item.id].disabled"
                  @update:checked="handleCheckboxChange(advancedOptions[item.id], true)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeTab.type === 'customColumns'">
      <div :class="[$style.standart_columns_list, $style.standart_columns_list_custom]">
        <div
          v-for="(item, index) in customColumns"
          :key="index"
          :class="$style.item"
        >
          <div :class="$style.item__row">
            <svg-sprite
              :name="item.icon.name"
              :type="item.icon.type"
              :size="item.icon.size"
            />
            <div :class="$style.name">
              {{ item.label }}
            </div>
            <div :class="$style.right_side">
              <div :class="$style.checkbox">
                <vgp-checkbox
                  :size="16"
                  :checked="item.isChecked"
                  @update:checked="handleCheckboxChange( item, false)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkPricingAccess } from '$$helpers/pricingHelper';
import { getNormalizedColumnName } from '../../ganttView/grid/columns/helpers';
import ColumnsConfig from '../../ganttView/grid/columns/columnsConfig';
import pricingHelper from '../../../helpers/pricingHelper';
import helpers from '../../columnsConfigBar/helpers';
import ganttViewModel from '$$ganttViewModel';
import constants from '../../columnsConfigBar/constants';

export default {
  name: 'ColumnsSettings',
  props: {
    columns: {
      type: Object,
      required: true,
    },
  },
  emits: [
    'column-visibility-change',
  ],
  data() {
    return {
      standartColumns: [],
      customColumns: [],
      advancedOptions: {},
      locales: __,
      tabs: [
        {
          type: 'standartColumns',
          title: __('columns_bar_standart_columns_tab'),
          width: 125,
        },
        {
          type: 'customColumns',
          title: __('columns_bar_custom_columns_tab'),
          width: 125,
        },
      ],
      activeTab: {
        type: 'standartColumns',
        title: __('columns_bar_standart_columns_tab'),

      },
    };
  },
  created() {
    this.prepareOptions();
  },
  methods: {
    handleCheckboxChange(option, isAdvanced = false) {
      option.isChecked = !option.isChecked;
      if (['start_date', 'end_date'].includes(option.id)) {
        if (option.isChecked) {
          this.advancedOptions[option.id].disabled = false;
        } else {
          this.advancedOptions[option.id].disabled = true;
          this.advancedOptions[option.id].isChecked = false;
        }
      }
      this.$emit('column-visibility-change', {
        id: option.id,
        mainColumnId: option.mainColumnId ?? null,
        isVisible: option.isChecked,
        isAdvanced,
      });
    },
    onChangeTab(obj) {
      this.activeTab = obj;
    },
    prepareOptions() {
      const configAdvancedOptions = ColumnsConfig.config.advancedOptions;
      const customColumns = [];
      const standartColumns = [];
      const advancedOptions = {};
      const projectData = ganttViewModel.getActiveViewData() || {};

      this.columns.forEach(column => {
        const columnName = getNormalizedColumnName(column);

        if (['comments', 'attachments'].includes(column.name) || !checkPricingAccess(columnName)) {
          return;
        }
        if ((column.isShowCheckbox || column.name === 'text') && pricingHelper.checkPricingAccess(helpers.getPricingColName(column))) {
          if (!(projectData.is_jira && column.name === 'creator')
                      && !((!projectData.gantt_id && column.name === 'jira_key') || (projectData.gantt_id && !projectData.is_jira && column.name === 'jira_key'))) {
            if (['start_date', 'end_date'].includes(column.name)) {
              advancedOptions[column.name] = {
                id: `${column.name}_time`,
                mainColumnId: column.name,
                label: __(`export_${`${column.name}_time`}_label`),
                isChecked: configAdvancedOptions[column.name].check,
                disabled: column.hide,
              };
              standartColumns.push({
                id: `${column.name}`,
                mainColumnId: column.name,
                icon: constants.STANDART_COLUMNS_ICONS[column.name],
                label: column.text || __(`gantt_grid_${column.name}`),
                isChecked: !column.hide,
                disabled: column.hide,
                option: true,
                optionIcon: constants.STANDART_COLUMNS_ICONS.advancedOptions[column.name],
                optionValue: __(`gantt_grid_option_${column.name}`),
                enabledOption: configAdvancedOptions[column.name].check,

              });
            } else {
              standartColumns.push({
                id: column.name,
                label: __(`gantt_grid_${column.name}`),
                isChecked: !column.hide,
                icon: constants.STANDART_COLUMNS_ICONS[column.name],
              });
            }
          }
        }
        if (column.isUserCustomColumn) {
          customColumns.push({
            id: column.name,
            label: column.label,
            isChecked: !column.hide,
            icon: constants.CUSTOM_COLUMNS.find(item => item.id === column.columnType).icon,
          });
        }
      });
      const groupedStandartColumns = helpers.groupedStandartColumns(standartColumns, true);

      this.advancedOptions = advancedOptions;
      this.standartColumns = groupedStandartColumns;
      this.customColumns = customColumns;
    },
  },

};
</script>

<style module lang="less">
.columns_settings_wrapper {
  display: flex;
  flex-direction: column;
}
.wrapper_label {
  font-size: 14px;
  line-height: 34px;
  color: #191919;
  font-family: "Lato-Bold";
  margin: 0 12px 10px;

}

.checkboxes_wrapper {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.checkbox_row_wrapper {
  display: flex;
  justify-content: space-between;
}
.standart_columns_list {
  padding: 8px 12px 32px 12px;

    &__group {
      padding-bottom: 8px;

        .title {
            display: flex;
            align-items: center;
            padding: 4px 0;
            cursor: default;
            white-space: nowrap;

            div {
                font-family: "Lato-Regular", sans-serif;
                font-size: 12px;
                line-height: 18px;
                color: #999999;
                text-transform: uppercase;
                margin-right: 8px;
            }

            .line {
                height: 1px;
                width: 100%;
                background: #e5e5e5;
            }
        }

    }
    &_custom {
        //height: calc(100vh - 260px);
    }
}
.item {
    &__row {
        display: flex;
        align-items: center;
        padding: 4px 0;

        &.option {
            padding-left: 28px;
        }

        &.option_disable {
          opacity: 0.5;
        }

        .name {
            font-family: "Lato-Regular", sans-serif;
            font-size: 14px;
            line-height: 16px;
            color: #191919;
            padding-left: 8px;
            cursor: default;
        }

        .right_side {
            display: flex;
            align-items: center;
            margin-left: auto;

            .edit {
                display: flex;
                padding-right: 8px;

                & > div {
                    font-family: "Lato-Regular", sans-serif;
                    font-size: 12px;
                }
            }

            .checkbox {
                display: flex;
                align-items: center;
            }
        }

        .checkbox {
            display: flex;
            align-items: center;
            margin-left: auto;
        }
    }
}
.stickyTabs {
    position: sticky;
    top: -1px;
    background: white;
    z-index: 10;
}
</style>
